import { CheckInLogDetails } from '@/features/check-in-logs/components';

const CheckInLogDetailsPage = () => {
  return <CheckInLogDetails />;
};

export default CheckInLogDetailsPage;
